<template>
<div class="chapter">
<div class="inner_page">
<p class="blq-normal"><i>Day’s Eden brightness still relieving<br/>The awful Night’s intense profound</i> …</p>
<p class="right"><span>— Goethe</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?11dafe88